<template>
  <div>
    <div v-show="(dialogVisible || updateDialog || isMask || photoDialogVisible)" class="mask"></div>
    <div class="home-pop" v-loading="loading">
      <div class="close-top" @click="closeDialog">
        <i class="el-icon-close" style="font-size: 28px;"></i>
      </div>
        <!-- 收货信息 -->
        <div class="activity-detail">
          <div class="title">收货信息</div>
          <div class="activity-detail-card">
            <div class="activity-detail-card-top">
              <!-- <div class="top-left">
                <span>活动名称：</span>
                <span v-if="detailList.gpThemeInfoDTO">{{
                  detailList.gpThemeInfoDTO.themeName
                }}</span>
              </div> -->
              <div class="top-left">
                <span>收货时间：</span>
                <span>{{ getTime(detailList.requestTime, "-") }}</span>
              </div>
            </div>
            <div class="activity-detail-card-main">
              <div class="main-list">
                <div class="main-item" style="margin-left: -110px">
                  <div class="item-left">
                    <span v-if="isAcross1 || isAcross2 || isAcross3" style="color:#cd1231;">*</span><span>合同：</span>
                  </div>
                  <div class="item-right" v-if="detailList.gpPoDTO.dagFileUri" @click="viewFile(detailList.gpPoDTO.dagFileUri)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="main-item">
                  <div class="item-left">
                    <span v-if="isAcross1 || isAcross2" style="color:#cd1231;">*</span><span>活动方案：</span>
                  </div>
                  <div class="item-right" v-if="detailList.gpPoDTO.solutionFileUri" @click="viewFile(detailList.gpPoDTO.solutionFileUri)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="main-item">
                  <div class="item-left">
                    <span v-if="isAcross1 || isAcross2" style="color:#cd1231;">*</span><span>送货单：</span>
                    </div>
                  <div class="item-right" v-if="detailList.deliveryFileUri" @click="viewFile(detailList.deliveryFileUri)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
              </div>
              <div class="main-list">
                <div class="main-item"  style="margin-left: -110px">
                  <div class="item-left">
                    <span v-if="isAcross1 || isAcross3" style="color:#cd1231;">*</span><span>完工报告：</span>
                  </div>
                  <div class="item-right" v-if="detailList.completeFileUri" @click="viewFile(detailList.completeFileUri)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="main-item">
                  <div class="item-left">
                    <!-- <span style="color:#cd1231;">*</span> -->
                    <span>差旅住宿费用明细和发票：</span>
                  </div>
                  <div class="item-right" v-if="detailList.feeFileUri" @click="viewFile(detailList.feeFileUri)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="main-item">
                  <div class="item-left">
                    <!-- <span style="color:#cd1231;">*</span> -->
                    <span>礼物受益者清单：</span>
                  </div>
                  <div class="item-right" v-if="detailList.giftFileUri" @click="viewFile(detailList.giftFileUri)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
              </div>
              <div class="main-list">
                <div class="main-item"  style="margin-left: -110px">
                  <div class="item-left">
                    <!-- <span style="color:#cd1231;">*</span> -->
                    <span> KPI证据：</span>
                  </div>
                  <div class="item-right" v-if="detailList.kpiFileUri" @click="viewFile(detailList.kpiFileUri)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="main-item">
                  <div class="item-left">
                    <!-- <span style="color:#cd1231;">*</span> -->
                    <span> 活动照片：</span>
                  </div>
                  <div class="item-right" v-if="detailList.photoFileDTOList&&detailList.photoFileDTOList.length>0" @click="showPhotoDialog(detailList.photoFileDTOList)">
                    查看附件
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
              </div>
              <!-- 负责人确认凭证有疑问，后端要如何返回 -->
              <!-- <div class="main-item">
                <div class="item-left" style="margin-left: -110px">
                  负责人确认凭证：
                </div>
                <div class="item-right" v-if="detailList.completeFileUri" @click="viewFile(detailList.completeFileUri)">
                  查看附件
                </div>
                <div v-else class="item-right item-blank">暂无附件</div>
              </div> -->
            </div>
            <div class="activity-detail-card-bottom">
              <!-- <div class="bottom-left">
                {{ getReceiveTypeName(detailList.receiveType)}}：
              </div> -->
              <div class="bottom-right">
                <div>
                  <span v-if="detailList.receiveType === '01'">
                  <span>本次收货比例：</span>
                  {{formatRatio(detailList.receiveRatio)}} ({{ formatPrice(detailList.receiveAmount) }} 元)
                </span>
                <span v-if="detailList.receiveType === '02'">
                  <span>本次收货金额：</span>
                  {{ formatPrice(detailList.receiveAmount) }} 元
                </span>
                </div>
                <!-- <div v-if="updateForm.ratio">
                  <span>修改比例：</span>
                  <span>{{(updateForm.ratio)}}% </span>
                  <span>({{ formatPrice(((updateForm.ratio/100)/(detailList.receiveRatio) * detailList.receiveAmount).toFixed() ) }} 元)</span>
                </div>
                <div v-if="updateForm.amount">
                  <span>修改金额：</span>
                  <span>{{ formatPrice(updateForm.amount) }} 元</span>
                </div> -->
                <div class="danger-btn" v-if="(detailList.receiveType === '01' && menuCode =='01')" size="small" type="danger" plain  @click="updateBtn">修改收货比例</div>
                <div class="danger-btn" v-if="(detailList.receiveType === '02' && menuCode =='01')" type="danger" plain  size="small"  @click="updateBtn">修改收货金额</div>
              </div>

            </div>

          </div>

        </div>

        <div v-if="detailList.requestStatus === 500" class="reverse-info">
          <el-row>
            <el-col :span="18">
              <div class="title">冲销记录</div>
            </el-col>
            <el-col :span="6">
              <div class="reverse-create">
                <el-button  size="small" type="danger" @click="showReverseCreate">新建冲销</el-button>
              </div>
            </el-col>
          </el-row>
          <div v-for="item in reverseList" :key="item.reverseId" class="content-card reverse-row">
            <el-row  class="reverse-row">
              <el-col :span="6">
                冲销日期： {{ getTime(item.requestTime, "-") }}
              </el-col>
              <el-col :span="6">
                冲销类型： {{ getReverseTypeName(item.reverseType, "-") }}
              </el-col>
              <el-col :span="12">
                <div v-if="item.reverseType === '01'" class="reverseValue">
                  冲销比例： {{formatRatio(item.reverseRatio)}} ({{ formatPrice(item.reverseAmount) }} 元)
                </div>
                <div v-if="item.reverseType === '02'" class="reverseValue">
                  冲销金额： {{ formatPrice(item.reverseAmount) }} 元
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-if="reverseList.length === 0" class="content-card" style="text-align:center;height: 40px;line-height: 40px;">
            还没有冲销记录
          </div>
        </div>
        <!-- 审批按钮 -->
        <div class="photo-bottom" v-if="isShowbtn &&  menuCode =='01'" >
          <!--              @open='isMask=ture'-->
          <DialogPop
            @confirm="reject"
            @getRejectaccount="getRejectaccount"
            :marLeft="true"
            :isRject="true"
            isType="1"
            btnText="退回"
            centerText="是否确认退回？"
            @open='openBtn'
            @closeOpen="closeOpen"
            :isReject="true"
            :modal="false"
          ></DialogPop>
          <DialogPop
            @confirm="agree"
            isType="0"
            btnText="通过"
            :modal="false"
            @open='openBtn'
            @closeOpen="closeOpen"
            centerText="是否确认通过？"
          >
          </DialogPop>
        </div>
        <!-- 紧急审批按钮 -->
        <div class="photo-bottom" v-if="isShowurgent && menuCode =='03'">
          <!-- v-if="isShowurgent &&  menuCode =='03'" -->
          <DialogPop
            @confirm="urgentAgree"
            isType="0"
            btnText="确认收货凭证"
            :modal="false"
            @open='openBtn'
            @closeOpen="closeOpen"
            centerText="是否确认收货凭证？"
          >
          </DialogPop>
        </div>
    </div>
    <el-dialog title="新建冲销" :modal="false" :visible.sync="dialogVisible" :close-on-click-modal="false" width="40%" v-loading="dialogLoading">
      <el-form ref="reverseForm" :rules="reverseRules" :model="reverseForm" label-width="90px" size="small" class="reverse-form">
        <el-form-item label="冲销类型" prop="reverseType">
          <!-- <el-radio v-model="reverseForm.reverseType" label="01">按比例收货</el-radio>
          <el-radio v-model="reverseForm.reverseType" label="02">按金额收货</el-radio> -->
          {{ getReverseTypeName(reverseForm.reverseType) }}
        </el-form-item>
        <el-form-item v-if="reverseForm.reverseType === '01'" label="冲销比例" prop="reverseRatio">
          <el-input v-model="reverseForm.reverseRatio" class="value-input" style="width: 120px;" /> %
        </el-form-item>
        <el-form-item v-if="reverseForm.reverseType === '02'" label="冲销金额" prop="reverseAmount">
          <el-input v-model="reverseForm.reverseAmount" class="value-input" style="width: 120px;" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <div class="update-footer">
          <div class="btn1" @click="dialogVisible = false">取消</div>
          <div class="btn2" @click="submitReverse">提交</div>
        </div> -->
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="danger" @click="submitReverse">提交</el-button>
      </span>
    </el-dialog>
    <el-dialog :modal="false"  :title="updateForm.title" :visible.sync="updateDialog" :close-on-click-modal="false" width="30%" v-loading="dialogLoading">
      <el-form  :inline="true" ref="reverseForm" :rules="updateFormRules"  :model="updateForm"  size="small" class="reverse-form" >
        <el-form-item  v-if="detailList.receiveType === '02'" label="初始金额" prop="oldAmount">
          <div style="width:120px">{{formatPrice(updateForm.oldAmount)}}元</div>
        </el-form-item>
        <el-form-item  v-if="detailList.receiveType === '02'"  label="修改金额" prop="newAmount" >
          <el-input   type="number" v-model="updateForm.newAmount" class="value-input" style="width: 120px;" :max = updateForm.oldAmount  @input="channgeInput(updateForm.newAmount)">
          </el-input>
        </el-form-item>
        <el-form-item v-if="detailList.receiveType === '01'" label="初始比例" prop="oldRatio">
          <div style="width:120px">{{formatRatio(updateForm.oldRatio)}}</div>
        </el-form-item>
        <el-form-item v-if="detailList.receiveType === '01'"  label="修改比例" prop="newRatio">
          <el-input type="number" v-model="updateForm.newRatio" class="value-input" style="width: 120px;" :max = updateForm.oldRatio*100 @input="channgeInput(updateForm.newRatio)">
            <!-- <template slot="append">%</template> -->
          </el-input>%
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <div class="update-footer">
          <div class="btn1" @click="updateDialog = false">取消</div>
          <div class="btn2" @click="submitUpdate" :disabled="updateDisabled">提交</div>  
        </div> -->
        <el-button  size="small" @click="closeUpdate()">取 消</el-button>
        <el-button  size="small" type="danger" :disabled="updateDisabled" @click="submitUpdate()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog top="5vh"  :visible.sync="photoDialogVisible" :close-on-click-modal="true" :modal="false" title="活动照片">
        <div class="image-group">
          <div v-for="(item, index) in photoFileDTOList" :key="index">
            <el-image
              :src="getImg(item.fileUri)"
              :preview-src-list="previewSrcList"
              :style="{ marginRight: '20px' }"
              fit="cover"
              class="image-group__item"
            />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="photoDialogVisible=false">返回</el-button>
        </span>
      </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { commonUtils } from "@/utils/common"
import gameplanApi from "../../api/gameplan"
import DialogPop from "./components/dialog-pop.vue"
import formValidators from '@/utils/formValidators'
// import { create, all } from 'mathjs/number'
// const math = create(all)
export default {
  name: "activityPhoto-salePlace-detail",
  components: {
    DialogPop,
  },
  props:{
    receiveId:{type:Number},
    menuCode:{type:String},
  },
  data() {
    const validateRatio = (rule, value, callback) => {
      if (value > 100) {
        callback(new Error('冲销比例不能大于100%'))
      } else {
        callback()
      }
    }
    return {
      activityPocId: "",
      detailList: {
        gpThemeInfoDTO: {
          gpPrDTO: {},
          themeChannels: []
        },
        gpPoDTO: {}
      },
      employeeLevel: "",
      gameplanLevel: "",
      // receiveId: "",
      reverseList: [],
      loading:false,
      dialogVisible: false,
      dialogLoading: false,
      reverseForm: {
        reverseType: '01',
        reverseRatio: '',
        reverseAmount: '',
      },
      reverseRules: {
        reverseType: [{ required: true, message: '请选择冲销类型', trigger: 'change' }],
        reverseRatio: [
          { required: true, message: '请填写冲销比例', trigger: 'change' },
          { validator: formValidators.checkNumber, trigger: 'change' },
          { validator: validateRatio, trigger: 'change' }
        ],
        reverseAmount: [
          { required: true, message: '请填写冲销金额', trigger: 'change' },
          { validator: formValidators.checkNumber, trigger: 'change' }
        ],
        detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'change' }]
      },
      updateDialog:false,
      updateForm:{
        title:'',
        oldRatio:null, // 初始比例
        newRatio:null, //修改比例
        oldAmount:null,  // 初始金额
        newAmount:null, //修改金额
        ratio:null,
        amount:null,
      },
      updateFormRules: {},
      updateDisabled: false,
      isMask: false,
      isAcross1: false,
      isAcross2: false,
      isAcross3: false,
      rejectAccount:'',
      photoFileDTOList:[],
      photoDialogVisible:false
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isShowbtn () {
      return this.detailList.requestStatus === 100
    },
    isShowurgent () {
      return this.detailList.requestStatus > 100
    },
    previewSrcList() {
      return this.photoFileDTOList.map(item => {
        return this.getImg(item.fileUri)
      })
    }
  },
  watch: {},
  created() {
    // console.log(this.receiveId,'receiveId');
    // console.log(this.menuCode,'menuCode');
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.getReceiptdetail()
      this.getReverseList()
    },        
    // 理由
    getRejectaccount (val) {
        this.rejectAccount = val
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    openBtn () {
      this.isMask = true
    },
    closeOpen () {
      this.isMask = false
    },
    getTime(timestamp, a) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + a;
        const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1): date.getMonth() + 1) + a;
        const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D + h + m + s;
      }
    },
    // 金额千分
    formatPrice(price) {
      return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 百分比
    formatRatio(ratio) {
      let str = Number(ratio*100).toFixed(1)
      return str + "%" ;
      // return ratio * 100 + '%'
    },
    getChannel(a, b) {
      let themeChannels = a;
      let arr = themeChannels
        .map((item) => {
          return item.themeChannelEnName;
        })
        .join(b);
      return arr;
    },
    viewFile(uri) {
      if (!uri) {
        return
      }
      window.open(this.getImg(uri))
    },
    getImg(uri) {
      return commonUtils.getImageUrl(uri);
    },

    // 收货审批详情接口
    async getReceiptdetail() {
      let params = {
        receiveId: this.receiveId,
      };
      let res = await gameplanApi.getGamepalnReceiptdetail(params);
      if (res.data.resultCode == "0") {
        this.detailList = res.data.resultData.receiveInfo;
        let gpPoDTO = this.detailList.gpPoDTO
        let gpPrDTO = this.detailList.gpThemeInfoDTO.gpPrDTO
        if (gpPoDTO.poAmount > 100000) {
          if (gpPrDTO.isAcross == 1) {
            this.isAcross1 = true
          } else {
            if (gpPrDTO.subPackage == 497) {
              this.isAcross2 = true 
            } else if (gpPrDTO.subPackage == 153){
              this.isAcross3 = true 
            }
            else{
              return
            }
          }     
        }
      } else {
        console.log("error");
      }
    },
    // 查询冲销记录
    async getReverseList() {
      if (!this.receiveId) {
        this.reverseList = []
        return
      }
      const params = {
        receiveId: this.receiveId,
      }
      const res = await gameplanApi.getPoReverseList(params)
      if (res.data.resultCode == "0") {
        this.reverseList = res.data.resultData.reverseList;
      } else {
        console.log("error");
      }
    },
    // 审批接口
    gamepalnActivityapprove(params) {
      this.loading = true
      gameplanApi.getGamepalnReceiptapprove(params).then((res) => {
        if (res.data.resultCode === "0") {
              this.loading = false
          if (params.processAction == '02') {
              this.$message.success('收货审批已通过');
              this.$router.go(0)
          } else if (params.processAction == '03') {
              this.$message.success('收货审批已退回');
              this.$router.go(0)
          }
        } else {
          console.log("error");
          this.loading = false
        }
      });
    },
    getReceiveTypeName (receiveType) {
      return '01' === receiveType ? '按比例收货' :
        '02' === receiveType ? '按金额收货' : ''
    },
    getReverseTypeName (reverseType) {
      return '01' === reverseType ? '按比例冲销' :
        '02' === reverseType ? '按金额冲销' : ''
    },
    // 驳回
    reject() {
      let params = {
        'receiveId': this.detailList.receiveId,
        'processAction': "03",
        'rejectReason':this.rejectAccount,
        'rejectPerson':this.userInfo.clientName,
      };
      if (this.detailList.receiveType === '01') {
        if (this.updateForm.ratio !== null) {
          params.receiveRatio = this.updateForm.ratio/100    
        }
      } else {
        if (this.updateForm.amount !== null) {
          params.receiveAmount = this.updateForm.amount
        }
      }
      this.gamepalnActivityapprove(params);
    },
    // 通过
    agree() {
      let params = {
        'receiveId': this.detailList.receiveId,
        'processAction': "02",
      };
      if (this.detailList.receiveType === '01') {
        if (this.updateForm.ratio !== null) {
          params.receiveRatio = this.updateForm.ratio/100
        }
      } else {
        if (this.updateForm.amount !== null) {
          params.receiveAmount = this.updateForm.amount
        }
      }
      this.gamepalnActivityapprove(params);
    },
    // 紧急通过
    urgentAgree () {
      this.loading = true
      gameplanApi.addAttachCheck(this.receiveId).then((res) => {
        // console.log(res,'紧急通过');
        if (res.data.resultCode === "0") {
          this.loading = false
          this.$message.success('紧急审批已通过');
          this.$router.go(0)
        } else {
          this.loading = false
        }
      }).catch((err) => {
          this.loading = false
          console.log(err)
        })
    },

    showReverseCreate() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.reverseForm.resetFields()
        this.reverseForm.reverseType = this.detailList.receiveType
      })
    },
    submitReverse () {
      this.$refs.reverseForm.validate((valid) => {
        if (valid) {
          const payload = {
            receiveId: this.receiveId,
            reverseType: this.reverseForm.reverseType,
            reverseRatio: '',
            reverseAmount: ''
          }
          if (this.reverseForm.reverseType === '01') {
            payload.reverseRatio = this.reverseForm.reverseRatio / 100
          }
          if (this.reverseForm.reverseType === '02') {
            payload.reverseAmount = this.reverseForm.reverseAmount
          }
          this.dialogLoading = true
          gameplanApi.submitReverse(payload).then(response => {
            this.dialogLoading = false
            if (response.data.resultCode === '0') {
              this.dialogVisible = false
              this.$message.success('冲销记录提交成功')
              this.$router.go(0)
            } else {
              this.dialogVisible = false
            }
          }).catch(() => {
            this.dialogLoading = false
          })
        }
      })
    },
    submitUpdate () {
      this.updateDialog = false
      if (this.detailList.receiveType === '01') {
        if ( this.updateForm.newRatio == '') {
          this.updateForm.newRatio = null
        }
        this.updateForm.ratio = this.updateForm.newRatio
      } else {
        if ( this.updateForm.newAmount == '') {
          this.updateForm.newAmount = null
        }
        this.updateForm.amount = this.updateForm.newAmount
      }
    },
    closeUpdate () {
      this.updateDialog = false
      this.updateForm.newRatio = null
      this.updateForm.newAmount = null
      this.updateForm.ratio = null
      this.updateForm.amount = null
    },
    updateBtn () {
      if (this.detailList.receiveType === '01') {
        this.updateForm.oldRatio = this.detailList.receiveRatio
        this.updateForm.title = '修改收货比例'
      } else {
        this.updateForm.oldAmount = this.detailList.receiveAmount
        this.updateForm.title = '修改收货金额'
      }
      this.updateDialog = true
    },
    channgeInput (val) {
      if (this.detailList.receiveType === '01') {
        if (val/100 > this.updateForm.oldRatio) { 
          this.$message.warning('修改比例不能超过初始比例')
          this.updateDisabled = true
        } else if (val < 0) {
          this.$message.warning('修改比例不能小于0')
          this.updateDisabled = true
        } else {
          this.updateDisabled = false
        }
      } else {
        if (val > this.updateForm.oldAmount) {
          this.$message.warning('修改金额不能超过初始金额')
          this.updateDisabled = true
        } else if (val < 0) {
          this.$message.warning('修改金额不能小于0')
          this.updateDisabled = true
        }
        else {
          this.updateDisabled = false
        }
      }
    },
    showPhotoDialog(photoFileDTOList){
      this.photoFileDTOList = photoFileDTOList
      this.photoDialogVisible = true
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  margin: 0 auto 15px;
}
::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 60vh;
}
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}
.mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7) ;
    z-index: 3;
}
.home-pop {
  position: relative;
  .close-top {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0px;
    right: 10px;
    cursor: pointer;
  }
  .title {
    // height: 50px;
    line-height: 50px;
    color: #101010;
    font-size: 18px;
    text-align: left;
    font-weight: 600;
    font-family: SourceHanSansSC-bold;
  }
  .activity-detail {
    margin-top: 20px;
    .activity-detail-card {
      padding: 10px 20px;
      background-color: #ffffff;
      border-radius: 10px;
      .activity-detail-card-top {
        display: flex;
        height: 30px;
        line-height: 30px;
        text-align: left;
        .top-left {
          font-size: 20px;
          font-weight: 600;
          color: #cd1231;
        }
        .top-right {
          font-size: 18px;
          flex: 1;
          color: #bbbbbb;
          text-align: right;
        }
      }
      .activity-detail-card-main {
        // display: flex;
        // flex-wrap: wrap;
        margin-top: 10px;
        .main-list {
          display: flex;
        }
        .main-item {
          width: 33%;
          font-size: 16px;
          display: flex;
          height: 50px;
          line-height: 50px;
          .item-left {
            width: 60%;
            color: #101010;
            height: 32px;
            line-height: 32px;
            text-align: right;
          }
          .item-right {
            color: #ffffff;
            background-color: #409eff;
            width: 114px;
            height: 30px;
            line-height: 30px;
            margin-top: 2px;
            border-radius: 4px;
            text-align: center;
            cursor: pointer;
          }
          .item-blank {
            background-color: #fff;
            color: #101010;
            cursor: auto;
          }
        }
      }
      .activity-detail-card-bottom {
        display: flex;
        line-height: 30px;
        .bottom-left {
          font-size: 20px;
          font-weight: 600;
          text-align: left;
          color: #101010;
        }
        .bottom-right {
          font-size: 16px;
          text-align: left;
          color: #cd1231;
          display: flex;
          .danger-btn {
            margin-left: 20px;
            width: 104px;
            // height: 32px;
            // line-height: 32px;
            font-size: 14px;
            font-weight: normal;
            border-radius: 4px;
            text-align: center;
            cursor: pointer;
            background-color: rgba(205, 18, 49, 1);
            color: rgba(255, 255, 255, 1);
            border: 1px solid rgba(205, 18, 49, 1);
          }
          
        }
      }
    }
  }
  .photo-fieldBuild {
    margin-top: 30px;
    .title {
      height: 50px;
      line-height: 50px;
      color: #101010;
      font-size: 20px;
      text-align: left;
      font-weight: bold;
      font-family: SourceHanSansSC-bold;
      display: flex;
      .right {
        width: 66px;
        height: 21px;
        line-height: 21px;
        margin-top: 15px;
        border-radius: 4px;
        background-color: #ffeaa6;
        color: #d19f00;
        font-size: 12px;
        text-align: center;
        font-family: Microsoft Yahei;
        margin-left: 5px;
      }
    }
    .photo-fieldBuild-card {
      padding: 10px 20px;
      background-color: #ffffff;
      font-size: 14px;
      color: #101010;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .card-item {
        width: 579px;
        height: 148px;
        font-weight: bold;
        margin-top: 10px;
        .top {
          height: 48px;
          line-height: 48px;
          text-align: left;
          font-family: Microsoft Yahei;
        }
        .photo {
          display: flex;
          flex-wrap: wrap;
          .photo-item {
            width: 100px;
            height: 100px;
            margin-right: 20px;
            img {
              width: 100px;
              height: 100px;
            }
          }
        }
      }
      .execution-time {
        position: absolute;
        top: 10px;
      }
    }
  }
  .reverse-info {
    .reverse-create {
      text-align: right;
      padding: 10px 5px 0 0;
    }
    .content-card {
      background-color: #ffffff;
      border-radius: 8px;
    }
    .reverse-row {
      line-height: 24px;
      margin-bottom: 3px;
      padding: 10px;
    }
    .reverseValue {
      color: #cd1231;
    }
  }
  .reverse-form {
    .value-input {
      width: 120px;
    }
    .el-radio {
      margin-right: 60px;
      .el-radio__input {
        display: inline-block;
        padding-right: 5px;
        &.is-checked .el-radio__inner {
          border-color: $base-red;
          background: $base-red;
        }
        &.is-checked+.el-radio__label {
          color: #101010;
        }
      }
    }
  }
  .photo-bottom {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    text-align: center;
  }
}
::v-deep.el-radio {
  color: #101010;
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }
    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }

}
::v-deep .dialog-footer {
.update-footer {

  display: flex ;
  justify-content: flex-end;
  .btn1 {
    width: 84px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-weight: normal;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 1);
    color: rgba(205, 18, 49, 1);
    border: 1px solid rgba(205, 18, 49, 1);
    margin-right: 10px;
  }
  .btn2 {
    width: 84px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-weight: normal;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    background-color: rgba(205, 18, 49, 1);
    color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(205, 18, 49, 1);
    }
  }
}
.image-group {
  display: flex;
  flex-wrap: wrap;
  & > div  {
    position: relative;
    margin-bottom: 5px;
    .el-icon-error {
      position: absolute;
      font-size: 22px;
      color: #bbb;
      top: -8px;
      left: 74px;
      background-color: #fff;
      cursor: pointer;
      border-radius: 100px;
      &:hover {
        color: #cd1231;
      }
    }
  }
  &__blank {
    width: 85px;
    height: 85px;
  }
  &__item {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    margin: 10px;
    cursor: pointer;
  }
  &__name {
    font-size: 12px;
    color: #666;
    text-align: center;
    margin-top: 4px;
    width: 85px;
    word-break: break-all;
  }
}
</style>
